import { Skeleton, SkeletonGroup } from '@/components/ui/skeleton'
import { isProduction } from '@/config/config'

/**
 * Bookkeeper's overview while it loads: the title and month, then its two columns of cards. Laid out as the
 * workspace lays Layer's overview out beside the rail; outside production the demo workspace notice heads it.
 */
export function BookkeeperOverviewSkeleton() {
  return (
    <SkeletonGroup className="mx-auto w-full max-w-[1488px] px-4 pt-6 pb-16">
      <span className="sr-only">Loading</span>
      {!isProduction && <Skeleton className="mx-6 mb-10 h-20" />}
      <div className="flex items-center justify-between px-6">
        <Skeleton className="h-9 w-44" />
        <Skeleton className="h-9 w-48" />
      </div>
      <div className="border-ink-200 mt-4 border-b" />
      <div className="grid grid-cols-1 items-start gap-6 px-6 pt-6 md:grid-cols-2">
        <Skeleton className="h-[610px]" />
        <Skeleton className="h-[545px]" />
        <Skeleton className="h-72" />
        <Skeleton className="h-72" />
      </div>
    </SkeletonGroup>
  )
}
